'use strict';

var DefaultRoleViewController = function DefaultRoleViewController($scope, dataRetrieverService, userManagementCommonCustomRenderers, userManagementConstants, userManagementSelectedRole) {
  $scope.components = null;
  $scope.mode = 'user-management-default-role-view-mode';
  $scope.gridId = 'user-management-roles';
  $scope.roleName = 'Default';
  $scope.customRenderers = userManagementCommonCustomRenderers;
  $scope.usersAssigned = userManagementSelectedRole.refreshUsersAssigned();
  dataRetrieverService.getDataRetriever('USER_MANAGEMENT_SCREEN', $scope.mode).setCustomSearchCriteriaRules([]);
  $scope.$watch('visible', function (isVisible) {
    if (isVisible) {
      $scope.open();
    }
  });
  $scope.open = function () {
    $scope.$broadcast('grid:loadData:' + $scope.gridId);
  };
  $scope.cancel = function () {
    $scope.visible = false;
    $scope.$emit('user-management-manage-users:change-screen', userManagementConstants.SCREEN_VALUE.MANAGE_USERS);
  };
};
DefaultRoleViewController.$inject = ['$scope', 'DataRetrieverService', 'UserManagementCommonCustomRenderers', 'UserManagementConstants', 'UserManagementSelectedRoleService'];
module.exports = DefaultRoleViewController;